/**
 * What each role code (dbo.Role.Code) is called on screen. STAFF is the tutor role, so it reads "Tutor", never
 * "Staff". The client roles (RoleTypeId 3) are held through a client link, not dbo.UserRoles.
 */
export const ROLE_LABELS: Readonly<Record<string, string>> = {
  ADMIN: 'IT admin',
  STAFF: 'Tutor',
  TTRCRD: 'Tutor coordinator',
  PRGMGR: 'Programme manager',
  TCMGR: 'Tuition consultant',
  RPTUSER: 'Report user',
  QA: 'QA',
  OPSADMIN: 'Operations admin',
  CLIENT: 'Client',
  CLREPORTS: 'Client reports',
  CUSTODIAN: 'Custodian',
  ASSESSOR: 'Assessor',
  STUDENT: 'Learner'
};

/** The on-screen name of a role code; an unknown code is shown as it is. */
export function roleLabel(code: string | null | undefined): string {
  const key = (code ?? '').trim();
  return ROLE_LABELS[key.toUpperCase()] ?? key;
}
